/* =========================================================================
   MediCarry — BOGO / tiered offer block
   Bundle-card tiers; the selected tier expands to per-slot COLOUR pickers.
   Each slot ("Bracelet 1", "Bracelet 2", ...) is a colour-swatch selector
   for the CURRENT product ONLY — no other products from the family are shown.
   Mirrors the standard product page's per-slot picker (script.js
   renderBundleSlots) so both bundle systems look and behave identically.
   Self-contained; runs only when [data-bogo] exists.
   ========================================================================= */
(function () {
  const root = document.querySelector('[data-bogo]');
  if (!root) return;

  const single = parseInt(root.dataset.single, 10) || 0;
  const currency = root.dataset.currency || 'GBP';
  const ctaLabel = document.querySelector('[data-bogo-cta-label]');
  const ctaPrice = document.querySelector('[data-bogo-cta-price]');
  const addBtn = document.querySelector('[data-bogo-add]');
  const floatLabel = document.getElementById('floatingLabel');
  const floatPrice = document.getElementById('floatingPrice');
  const floatAdd = document.getElementById('floatingAdd');

  const fmt = (c) => {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(c / 100); }
    catch (e) { return '£' + (c / 100).toFixed(c % 100 ? 2 : 0); }
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  // Swatch background — mirrors snippets/colour-swatch.liquid + script.js getSwatchBg
  function swatchBg(value) {
    const v = String(value || '').toLowerCase();
    if (v.includes('blue')) return 'linear-gradient(135deg, #0a0a0a 50%, #1d4ed8 50%)';
    if (v.includes('silver')) return 'linear-gradient(135deg, #8f8f8f, #d0d0d0 50%, #707070)';
    if (v.includes('gold')) return 'linear-gradient(135deg, #b8842f, #f6e2b0 50%, #cc9a44)';
    if (v.includes('red')) return 'linear-gradient(135deg, #0a0a0a 50%, #b91c1c 50%)';
    if (v.includes('green')) return 'linear-gradient(135deg, #0a0a0a 50%, #15803d 50%)';
    return '#0a0a0a';
  }

  // --- current product (embedded JSON, same source as script.js) -----------
  let product = null;
  try { product = JSON.parse(document.querySelector('[data-product-json]').textContent); } catch (e) {}
  if (!product) { root.hidden = true; return; }

  // --- Cross-product bundle (custom.colour_links) ---------------------------
  // When enabled, each Buy-2 slot resolves to the dedicated single-variant
  // PRODUCT for that colour/type instead of a variant on THIS product. Gated
  // behind window.MC_CROSS_BUNDLE so it stays dormant (preview keeps adding this
  // product's own variants, which still works) until the split products are
  // published + the orphan variants removed at go-live.
  let CL = null;
  try { const _cl = document.querySelector('[data-colour-links]'); if (_cl) CL = JSON.parse(_cl.textContent); } catch (e) {}
  const CL_HAS_TYPE = !!(CL && (CL.entries || []).some(e => e.type));
  let currentType = null;         // selected Type value; null when product has no Type option
  function crossOn() { return window.MC_CROSS_BUNDLE === true && !!(CL && CL.entries && CL.entries.length); }
  function clColours() {
    const out = [];
    ((CL && CL.entries) || []).forEach(e => {
      if (CL_HAS_TYPE && currentType && e.type && e.type !== currentType) return;
      if (!out.some(c => c.toLowerCase() === String(e.colour).toLowerCase())) out.push(e.colour);
    });
    return out;
  }
  function clVariant(colour) {
    const e = ((CL && CL.entries) || []).find(x =>
      String(x.colour).toLowerCase() === String(colour).toLowerCase()
      && (!CL_HAS_TYPE || !currentType || x.type === currentType));
    return e ? e.variant : null;
  }

  const optionNames = (product.options || []).map(o => typeof o === 'string' ? o : (o && o.name ? o.name : ''));
  const colourIdx = optionNames.findIndex(n => /colou?r/i.test(n));
  const typeIdx = optionNames.findIndex(n => /^type/i.test(n));

  function colourValues() {
    if (crossOn()) { const c = clColours(); if (c.length) return c; }
    return Array.from(new Set(
      (product.variants || []).map(v => colourIdx !== -1 ? String(v.options[colourIdx]) : (v.title || '')).filter(Boolean)
    ));
  }
  // Match a variant by colour, and — when the product has a Type option
  // (Type 1 / Type 2 Diabetes) — also by the currently selected Type.
  function variantFor(colour, type) {
    const match = v =>
      (colourIdx !== -1 ? String(v.options[colourIdx]) : (v.title || '')).toLowerCase() === String(colour).toLowerCase()
      && (type == null || typeIdx === -1 || String(v.options[typeIdx]).toLowerCase() === String(type).toLowerCase());
    return (product.variants || []).find(v => match(v) && v.available !== false) || (product.variants || []).find(match);
  }
  function variantId(colour) {
    if (crossOn()) { const v = clVariant(colour); if (v) return v; }
    const v = variantFor(colour, currentType); return v ? v.id : null;
  }

  let COLOURS = colourValues();
  if (!COLOURS.length) { root.hidden = true; return; }

  let activeQty = 1, activePay = 1, slotsWrap = null, activeTierPrice = null;
  // currentType is declared above (needed by colourValues/clColours).
  const slotColours = [];         // one colour name per slot

  // Default colour: ?variant= colour, else hero's active swatch, else first colour.
  function defaultColour() {
    try {
      const vid = parseInt(new URLSearchParams(location.search).get('variant'), 10);
      if (vid) {
        const v = (product.variants || []).find(x => x.id === vid);
        if (v) { const c = colourIdx !== -1 ? String(v.options[colourIdx]) : v.title; if (c) return c; }
      }
    } catch (e) {}
    const heroActive = document.querySelector('#parentColourSwatches .colour-swatch.active');
    if (heroActive && heroActive.dataset.colour) return heroActive.dataset.colour;
    return COLOURS[0];
  }

  function slotHtml(colour, i) {
    const free = i >= activePay;
    const sw = COLOURS.map(c =>
      `<button type="button" class="colour-swatch${c.toLowerCase() === String(colour).toLowerCase() ? ' active' : ''}" data-colour="${esc(c)}" aria-label="${esc(c)}"><span class="swatch" style="background:${swatchBg(c)}"></span></button>`
    ).join('');
    return `<div class="bundle-slot" data-slot="${i}">
      <span class="bundle-slot__label">Bracelet ${i + 1}${free ? ' · Free' : ''}</span>
      <div class="bundle-slot__swatches">${sw}</div>
      <span class="bundle-slot__name">${esc(colour)}</span>
    </div>`;
  }
  function renderSlots() {
    if (!slotsWrap) return;
    slotsWrap.innerHTML = slotColours.map(slotHtml).join('');
  }

  function setTier(card) {
    root.querySelectorAll('[data-bogo-tier]').forEach(c => c.classList.toggle('is-active', c === card));
    activeQty = parseInt(card.dataset.qty, 10);
    activePay = parseInt(card.dataset.pay, 10);
    activeTierPrice = card.dataset.tierPrice ? parseInt(card.dataset.tierPrice, 10) : null;
    slotsWrap = card.querySelector('[data-bogo-slots]');
    const def = defaultColour();
    while (slotColours.length < activeQty) slotColours.push(def);
    slotColours.length = activeQty;
    // Buy 1: the single bracelet is controlled by the hero colour swatches, so
    // no per-slot selector is shown. Keep slot 0 synced to the hero for add-to-cart.
    const label = slotsWrap ? slotsWrap.parentElement.querySelector('p') : null;
    if (activeQty === 1) {
      slotColours[0] = def;
      if (slotsWrap) slotsWrap.innerHTML = '';
      if (label) label.hidden = true;
    } else {
      if (label) label.hidden = false;
      renderSlots();
    }
    updateCta();
  }

  // Reflect a chosen slot colour in the hero colour selector + gallery
  // (script.js listens for 'hero:setColour'). We also pass the colour_links
  // image URL so the gallery can locate the photo by image (DURABLE — the photo
  // stays in product media even after the orphan variant is deleted) rather than
  // via a variant reference that disappears with the variant.
  function clImage(colour) {
    const e = ((CL && CL.entries) || []).find(x =>
      String(x.colour).toLowerCase() === String(colour).toLowerCase()
      && (!CL_HAS_TYPE || !currentType || x.type === currentType));
    return e ? e.image : null;
  }
  function syncHero(colour) {
    document.dispatchEvent(new CustomEvent('hero:setColour', { detail: { colour, image: clImage(colour) } }));
  }

  function parseMoney(text) {
    if (!text) return 0;
    const cleaned = String(text).replace(/[^0-9.,]/g, '');
    if (!cleaned) return 0;
    const dec = Math.max(cleaned.lastIndexOf(','), cleaned.lastIndexOf('.'));
    let norm;
    if (dec !== -1 && cleaned.length - dec - 1 <= 2) norm = cleaned.slice(0, dec).replace(/[.,]/g, '') + '.' + cleaned.slice(dec + 1).replace(/[.,]/g, '');
    else norm = cleaned.replace(/[.,]/g, '');
    const v = parseFloat(norm); return isNaN(v) ? 0 : Math.round(v * 100);
  }
  function updateCta() {
    let count = activeQty, cents = (activeTierPrice != null && !isNaN(activeTierPrice)) ? activeTierPrice : single * activePay;
    document.querySelectorAll('[data-upsell-card]').forEach(card => {
      const sw = card.querySelector('[data-upsell-switch]');
      if (sw && sw.getAttribute('aria-checked') === 'true') {
        count++;
        const pe = card.querySelector('[data-upsell-price]');
        cents += pe ? parseMoney(pe.textContent) : 0;
      }
    });
    if (ctaLabel) ctaLabel.textContent = 'Add to cart';
    if (ctaPrice) ctaPrice.textContent = fmt(cents);
    // Mirror onto the floating sticky bar so it reflects the active tier + upsells.
    if (floatLabel) floatLabel.textContent = 'Add to cart';
    if (floatPrice) floatPrice.textContent = fmt(cents);
  }

  async function addToCart() {
    // Backend-only source tags. Keys are '_'-prefixed → hidden from the customer in
    // cart/checkout/emails, but stored on the order line item for later attribution.
    // Do NOT affect discount eligibility (matched by product/qty) or pricing. The same
    // tag object on every bundle slot preserves same-colour line merging.
    // Only the multi-buy tier (qty >= 2 = the "Buy 2 Bracelets, 35% off" offer) is tagged
    // as pdp-offer; a single bracelet gets a neutral pdp-single and is not counted as the offer.
    const offerProps = { _added_at: 'product-page', _added_via: activeQty >= 2 ? 'pdp-offer' : 'pdp-single' };
    const addonProps = { _added_at: 'product-page', _added_via: 'pdp-addon' };
    const items = slotColours.map(variantId).filter(Boolean).map(id => ({ id, quantity: 1, properties: offerProps }));
    if (!items.length) return;
    document.querySelectorAll('[data-upsell-card]').forEach(card => {
      const sw = card.querySelector('[data-upsell-switch]');
      if (sw && sw.getAttribute('aria-checked') === 'true') { const vid = parseInt(sw.dataset.currentVariant, 10); if (vid) items.push({ id: vid, quantity: 1, properties: addonProps }); }
    });
    addBtn.disabled = true;
    try {
      await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      try { const c = await (await fetch('/cart.js', { credentials: 'same-origin' })).json(); const el = document.getElementById('cartCount'); if (el) { el.textContent = c.item_count; el.classList.remove('hidden'); } } catch (e) {}
      const cartBtn = document.getElementById('cartBtn'); if (cartBtn) cartBtn.click();
    } finally { addBtn.disabled = false; }
  }

  function init() {
    // Seed the selected Type from the hero's active Type pill (diabetes pages).
    const activePill = document.querySelector('.type-pill.active[data-type]') || document.querySelector('.type-pill[data-type]');
    currentType = activePill ? activePill.dataset.type : null;

    root.querySelectorAll('[data-bogo-tier]').forEach(card => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('[data-bogo-slots]')) return;
        if (!card.classList.contains('is-active')) setTier(card);
      });
    });
    setTier(root.querySelector('[data-bogo-tier].is-active') || root.querySelector('[data-bogo-tier]'));
    if (addBtn) addBtn.addEventListener('click', addToCart);
    if (floatAdd) floatAdd.addEventListener('click', addToCart);

    // Toggling a "Pair with" add-on should update the CTA count + price.
    document.addEventListener('click', (e) => { if (e.target.closest('[data-upsell-switch]')) setTimeout(updateCta, 0); });
    document.addEventListener('upsell:changed', () => updateCta());

    // Hero colour swatch → set EVERY slot to that colour. Delegated + deferred so
    // it runs AFTER script.js's own colour-swatch handler (which clears .active
    // from every swatch on the page, including our bundle slots) — otherwise the
    // active tier's per-slot selectors wouldn't follow the hero.
    document.addEventListener('click', (e) => {
      const heroSw = e.target.closest('#parentColourSwatches .colour-swatch[data-colour]');
      if (!heroSw) return;
      const col = heroSw.dataset.colour;
      if (!col) return;
      setTimeout(() => {
        for (let i = 0; i < slotColours.length; i++) slotColours[i] = col;
        if (activeQty > 1) renderSlots();
        updateCta();
      }, 0);
    });

    // Hero Type pill (Type 1 / Type 2 Diabetes) → rebuild slot colours for that
    // Type, keeping each slot's colour where the colour still exists.
    document.querySelectorAll('.type-pill[data-type]').forEach(btn => {
      btn.addEventListener('click', () => {
        const t = btn.dataset.type;
        if (!t || t === currentType) return;
        currentType = t;
        COLOURS = colourValues();
        if (!COLOURS.length) return;
        for (let i = 0; i < slotColours.length; i++) {
          if (!COLOURS.some(c => c.toLowerCase() === String(slotColours[i]).toLowerCase())) slotColours[i] = COLOURS[0];
        }
        renderSlots();
        updateCta();
      });
    });

    // Bundle swatch clicks (delegated) — set THIS slot's colour only.
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('.bundle-slot .colour-swatch');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation(); // don't bubble to the tier card
      const slot = btn.closest('.bundle-slot');
      const i = parseInt(slot.dataset.slot, 10);
      const col = btn.dataset.colour;
      slotColours[i] = col;
      slot.querySelectorAll('.colour-swatch').forEach(s => s.classList.toggle('active', s === btn));
      const nm = slot.querySelector('.bundle-slot__name'); if (nm) nm.textContent = col;
      syncHero(col);
      updateCta();
    });
  }

  init();
})();
